<template>
    <div>
        <div>
            <button @click="navigateTo">点我(navigateTo)</button>
        </div>
        <divider></divider>
        <div>
            <button @click="postMessage">点我(postMessage)</button>
        </div>
        <divider></divider>
        <div>
            <button @click="redirectTo">点我(redirectTo)</button>
        </div>
        <divider></divider>
        <div>
            <button @click="navigateToMiniProgram">点我(navigateToMiniPr)</button>
        </div>
        <div>
            {{test_text}}
        </div>
        <div>
            {{test_text2}}
        </div>
        <Wp_article_markdown></Wp_article_markdown>
    </div>
</template>

<script>

    import Wp_article_markdown from "../custom/Wp_article_markdown";
    export default {
        name: "Wp_test",
        components: {Wp_article_markdown},
        data() {
            return {
                url: "http://a004.28pay.com",
                text: "品牌正品特卖",
                test_text: '',
                test_text2: '',
            }
        },
        created() {
            this.test_text = this.$common.getUrlParams();
            this.test_text2 = this.$common.getUrlKey('openid');
        },
        methods: {
            serialize(data) {
                let s = "";
                for (let p in data)
                    s += "&" + p + "=" + encodeURIComponent(data[p]).replace(/\+/gm, "%2B");
                s = s.length > 0 ? s.substring(1) : s;
                return s;
            },
            navigateTo() {
                this.$wx.miniProgram.navigateTo({
                    url: "/pages/jd/jd?" + this.serialize({
                        _t: Date.now(), /* 本次消息的唯一编码，用于微信小程序将处理结果反馈给H5 */
                        cmd: "do", /* 业务指令 */
                        jd: "https://u.jd.com/eJrAqk" /* 业务指令的执行参数 */
                    })
                });
            },
            postMessage() {
                this.$wx.miniProgram.postMessage({
                    data: {a: "32123", b: "4333"}
                });
            },
            redirectTo() {
                this.$wx.miniProgram.redirectTo({
                    url: "/pages/jd/jd?" + this.serialize({
                        _t: Date.now(), /* 本次消息的唯一编码，用于微信小程序将处理结果反馈给H5 */
                        cmd: "do", /* 业务指令 */
                        jd: "https://u.jd.com/eJrAqk" /* 业务指令的执行参数 */
                    })
                });
            },
            navigateToMiniProgram() {
                let s = "https://u.jd.com/eJrAqk";
                this.$wx.miniProgram.navigateToMiniProgram({
                    path: "pages/union/proxy/proxy",
                    target: "miniProgram",
                    appId: "wx91d27dbf599dff74",
                    extraData: s
                });
            }

        }
    }
</script>

<style scoped>

</style>